import React, { useEffect, useState } from "react";
import "../assets/styles/Reglages.css";
import CustomLayout from "./CustomLayout";
import MaskedInput from "antd-mask-input";
import {
  Form,
  Input,
  Button,
  Checkbox,
  Typography,
  Card,
  Space,
  message,
  Spin,
} from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { database, auth } from "../modules/fireBase";
const { Title, Text } = Typography;
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 18,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 6,
    span: 18,
  },
};

export default function Reglages() {
  const onFinish = async (values) => {
    console.log("Success:", values);
    database
      .ref("reglages")
      .set(values)
      .then(() => {
        message.success("Les paramètres ont été sauvegardés");
      })
      .catch((err) => {
        message.error(err);
      });
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    console.log();
    message.error(confirmationPhoneNumber.errorMsg);
  };
  const validatePhoneNumber = (
    phonenumber,
    _sendconfirmation = sendconfirmation
  ) => {
    if (phonenumber?.length === 10 || !_sendconfirmation) {
      return {
        validateStatus: "success",
        errorMsg: null,
      };
    }
    return {
      validateStatus: "error",
      errorMsg: "Veuillez indiquer un numéro de téléphone valide",
    };
  };
  const [savedReglages, setSavedReglages] = useState(undefined);
  const [sendconfirmation, setSendConfirmation] = useState(undefined);
  const [confirmationPhoneNumber, setConfirmationPhoneNumber] =
    useState(undefined);
  useEffect(() => {
    database.ref("reglages").once("value", (snapshot) => {
      if (snapshot.val()) {
        // console.log(snapshot.val());
        setSavedReglages(snapshot.val());
        setConfirmationPhoneNumber(snapshot.val().confirmationnumber);
        setSendConfirmation(snapshot.val().sendconfirmation);
      }
    });
  }, []);
  return (
    <CustomLayout
      selectedKey="6"
      contentStyle={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Title>Réglages</Title>
      <div
        style={{
          flex: 1,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            width: "100%",
            maxWidth: 800,
            textAlign: "initial",
            marginTop: 50,
          }}
        >
          {savedReglages ? (
            <Form
              {...tailLayout}
              name="reglages"
              initialValues={savedReglages}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Card title="Envoyer aux personnes suivantes :">
                <Form.Item name="sendannule" valuePropName="checked">
                  <Checkbox>ANNULÉ</Checkbox>
                </Form.Item>
                <Form.Item name="sendconge" valuePropName="checked">
                  <Checkbox>CONGÉ</Checkbox>
                </Form.Item>
                <Form.Item name="sendoff" valuePropName="checked">
                  <Checkbox>OFF</Checkbox>
                </Form.Item>
                <Form.Item name="sendoutxjours" valuePropName="checked">
                  <Checkbox>OUT X jours</Checkbox>
                </Form.Item>
                <Form.Item name="sendout" valuePropName="checked">
                  <Checkbox>OUT</Checkbox>
                </Form.Item>
                <Form.Item name="sendretour" valuePropName="checked">
                  <Checkbox>Retour</Checkbox>
                </Form.Item>
                <Form.Item name="sendaconfirmer" valuePropName="checked">
                  <Checkbox>À confirmer</Checkbox>
                </Form.Item>
              </Card>
              <Card title="Confirmation" style={{ marginTop: 20 }}>
                <Form.Item {...tailLayout}>
                  <Space>
                    <Form.Item name="sendconfirmation" valuePropName="checked">
                      <Checkbox
                        onChange={(e) => {
                          setSendConfirmation(e.target.checked);
                          setConfirmationPhoneNumber({
                            ...validatePhoneNumber(
                              confirmationPhoneNumber?.number,
                              e.target.checked
                            ),
                            number: confirmationPhoneNumber?.number,
                          });
                        }}
                      >
                        Envoyer un message de confirmation au numéro suivant :
                      </Checkbox>
                    </Form.Item>
                    <Form.Item
                      name="confirmationnumber"
                      validateStatus={confirmationPhoneNumber?.validateStatus}
                      help={confirmationPhoneNumber?.errorMsg}
                      rules={[
                        {
                          validator: async (rule, value) => {
                            if (sendconfirmation) {
                              let number = value.replace(/_/g, "");
                              if (!(number.length === 14)) {
                                throw new Error(" ");
                              }
                            }
                          },
                        },
                      ]}
                    >
                      <MaskedInput
                        mask="(111) 111-1111"
                        size="10"
                        disabled={!sendconfirmation}
                        style={{ width: 125 }}
                        onChange={(e) => {
                          let number = e.target.value.replace(
                            /\(|\)|-|_| /g,
                            ""
                          );
                          setConfirmationPhoneNumber({
                            ...validatePhoneNumber(number),
                            number: e.target.value,
                          });
                        }}
                      />
                    </Form.Item>
                  </Space>
                </Form.Item>
              </Card>
              <Form.Item {...tailLayout} style={{ marginTop: 20 }}>
                <Button
                  type="primary"
                  htmlType="submit"
                  icon={<SaveOutlined />}
                >
                  Sauvegarder
                </Button>
              </Form.Item>
            </Form>
          ) : (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Spin size="large" className="loader" />
            </div>
          )}
        </div>
      </div>
    </CustomLayout>
  );
}
